import React from 'react';
import './LinkButton.css';

interface LinkButtonProps {
    title: string;
    onClick?: () => void;
    disabled?: boolean;
    ariaLabel?: string;
    /** Occupy a row of its own — used where several options stack vertically. */
    block?: boolean;
}

/**
 * Text-style secondary action ("Log in with my phone number instead" etc.), based on the
 * equivalent control in televeda-bootstrap's `pages/login.html`.
 *
 * Stays a <button> rather than an <a>: most uses trigger an action (resend the code, switch
 * verification method) rather than navigating, and an <a> without a real href isn't
 * focusable or announced as actionable. Spacing lives in LinkButton.css so that stacked
 * links sit close together instead of each carrying a full 1em gap.
 */
const LinkButton = ({ title, onClick, disabled = false, ariaLabel, block = false }: LinkButtonProps) => {
  const button = (
    <button
      type='button'
      className='btn btn-clean link-button u-color-primary u-hover-color-primary-light'
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {title}
    </button>
  );

  if (!block) return button;

  return <div className='link-button-row'>{button}</div>;
};

export default LinkButton
